<script>
// import Translations from "./insert-me-to-translate.vue";

import { reactive, ref, inject } from '@vue/composition-api'
import { voucherApi } from "./vouch-digital-client"

export default {
    setup(_, ctx) {
        const store = ctx.root.$store
        const trans = {
            "title_convert": gettext("Conversion request <b>Digital Vouchers</b> in credits"),
            "voucher": gettext("Voucher"),
            "credits": gettext("Credits"),
            "convert": gettext("CONVERT")
        }

        const voucherCredits = inject('voucherCredits')
        const voucher = inject('voucher')
        const status = inject('status')
        const redeemUrl = inject('redeemUrl')
        const status_checked = inject('status_checked')
        const status_confirmed = inject('status_confirmed')
        const cookies = inject('cookies')


        const redeemVoucher = () => {
            store.dispatch("ui/loader/show")
            voucherApi(voucher.value, redeemUrl, cookies.value.get('csrftoken')).then((response) => {
                try {
                    status.value = status_confirmed
                } catch(error){
                    console.log(response)
                }
                store.dispatch("ui/loader/hide")
            }).catch((response) => {
                console.log(response)
                console.log(response.status)
                console.log(response.data)
                store.dispatch("ui/loader/hide")
            })
        }

        return {
            trans,
            voucher,
            voucherCredits,
            status,
            status_checked,
            redeemVoucher
        }
    },
    mounted() {
        this.cookies = this.$cookies
    }
}
</script>

<template>
    <div>
        <div class="col">
            <h4 class="d-flex justify-content-between align-items-center">
                <span v-html="trans.title_convert"></span>
            </h4>
        </div>
        <div class="col mt-4">
            <ul class="list-group">
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    {{trans.voucher}}
                    <span><b>{{voucher}}</b></span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    {{trans.credits}}
                    <span><b>{{ voucherCredits }}</b></span>
                </li>
            </ul>
            <div class="col mt-4">
                <button class="btn btn-primary" @click="redeemVoucher">{{trans.convert}}</button>
            </div>
        </div>
    </div>
</template>

